import Vuex from 'vuex';
import Axios from 'axios';
import createPersistedState from 'vuex-persistedstate';
import Concrete from '../concrete';
import LocalForage from 'localforage';

const unautorize = function (error){
    if( error.status === 401 ){
        return true;
    }
    else if(error.hasOwnProperty('response')){
        if( error.response.status === 401 ){
            return true;
        }
    }
    return false;
};

export default class ConcreteStore extends Vuex.Store{
    constructor (options={}, vueInstance=null) {
        // allowNotAuthenticatedUser option setté à true supprime la vérification
        // par requête qui vérifie si l'utilisateur est authentifié
        if(vueInstance !== null){
            vueInstance.use(Vuex);
        }
        if (options.metaDefinition === undefined){
            throw Error('Store option should define a metaDefinition key');
        }
        if (options.apiRootUrl === undefined){
            throw Error('Store option should define a apiRootUrl key');
        }
        let ApiStore = Concrete.init(
            options.metaDefinition,
            options.apiRootUrl
        );

        let localStorageKey = options.apiRootUrl.replace(
            /^https?:\/\//, '').replace(/\/.*$/, '');

        let persistencePlugin = createPersistedState({
            key: localStorageKey,
            paths: [
                'api.auth',
            ],
        });

        options.modules = options.modules || {};
        options.modules.api = ApiStore;

        options.plugins = options.plugins || [];
        options.plugins.push(persistencePlugin);

        super(options);

        this.axios = Axios.create({
            baseURL: options.apiRootUrl,
            // timeout: 100000,
        });

        // Add a request interceptor
        let store = this;
        store.state.allowNotAuthenticatedUser = options.allowNotAuthenticatedUser;
        this.axios.interceptors.request.use(function (config) {
            if(store.state.api.auth.user.authenticated){
                config.headers.Authorization = `Token ${store.state.api.auth.user.token}`;
            }
            else{
                if(!config.url.startsWith('/auth/') && options.allowNotAuthenticatedUser !== true){
                    config.cancelToken = new Axios.CancelToken(function(cancel){
                        return cancel('request canceled, Unhauthorized');
                    });
                }
            }
            // Do something before request is sent
            return config;
        }, function (error) {
            // Do something with request error
            return Promise.reject(error);
        });

        this.axios.interceptors.response.use(function (response) {
            // Do something with response data
            return response;
        }, function (error) {
            // Do something with response error
            if(store.state.api.auth.user.authenticated){
                if (unautorize(error)){
                    store.dispatch('logoutUser');
                }
            }
            return Promise.reject(error);
        });
        this.commit('SET_API_ROOT_URL', options.apiRootUrl);
        this.storeCacheValues(store).then(() => {
            this.dispatch('initialFetchModels');
        });
    }

    storeCacheValues (store){
        // si un/des model à la clé persistent alors on récupére les données local qu'on met dans le store en mettant bien à jour le timestamp_end  afin que lors des requetes on prenne que la différence entre ce qu'il ya il sur le server et ce qu'on a en local
        // les données dans le local sotrage sont stocké de la même manière que dans le state, c'est à dire sous form d'objet avec uid en clé et l'objet en valeur
        let listModels = store.state.api.meta.listModels;
        let promises = [];
        for(let modelName in listModels){
            if(listModels[modelName].persistent){
                promises.push(LocalForage.getItem(modelName).then((val) => {
                    if (val === null) {
                        return;
                    }
                    store.commit(
                        'UPDATE_LIST', {
                            modelName: modelName,
                            list: Object.values(val.list)
                        }
                    );
                    store.commit(
                        'UPDATE_MODEL_TIMESTAMP', {
                            modelName: modelName,
                            timestamp: val.timestamp
                        }
                    );
                }));
            }
        }
        return Promise.all(promises);
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/concretejs/store/index.js
// module id = null
// module chunks = 